require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[7169],{

/***/ 53356:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = exports.BiContext = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const reactProps = {
  children: 1,
  key: 1,
  ref: 1
};
const BiContext = exports.BiContext = (0, _react.createContext)({});
class ContextProvider extends _react.Component {
  render() {
    const prunedProps = {};
    Object.keys(this.props).forEach(key => {
      if (!reactProps[key]) {
        prunedProps[key] = this.props[key];
      }
    });
    return /*#__PURE__*/_react.default.createElement(BiContext.Consumer, null, biContext => /*#__PURE__*/_react.default.createElement(BiContext.Provider, {
      value: {
        ...biContext,
        ...prunedProps
      }
    }, this.props.children));
  }
}
exports["default"] = ContextProvider;
(0, _defineProperty2.default)(ContextProvider, "propTypes", {
  children: _propTypes.default.node
});

/***/ }),

/***/ 12099:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _ContextProvider = _interopRequireDefault(__webpack_require__(53356));
exports.ContextProvider = _ContextProvider.default;
var _withContext = _interopRequireDefault(__webpack_require__(80233));
exports.withContext = _withContext.default;

/***/ }),

/***/ 80233:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = withContext;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _ContextProvider = __webpack_require__(53356);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  forOwn,
  assign
} = _utils.lodash;
function addStringProperty(dest, source, name, key) {
  const segments = name.split('.');
  let value = source;
  for (let i = 0; i < segments.length; i += 1) {
    value = value[segments[i]];
  }
  dest[key != null ? key : segments.pop()] = value;
}
function addObjectProperty(dest, source, obj) {
  forOwn(obj, (value, key) => {
    addStringProperty(dest, source, value, key);
  });
}
function addFunctionProperty(dest, source, func, ownProps) {
  const result = func(source, ownProps);
  if (result && typeof result === 'object') {
    assign(dest, result);
  }
}
function addProperty(dest, source, arg, ownProps) {
  switch (typeof arg) {
    case 'string':
      addStringProperty(dest, source, arg);
      break;
    case 'object':
      addObjectProperty(dest, source, arg);
      break;
    case 'function':
      addFunctionProperty(dest, source, arg, ownProps);
      break;
    default:
  }
}
function withContext() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return function (ComponentClass) {
    // eslint-disable-line func-names
    class WithContext extends _react.Component {
      render() {
        return /*#__PURE__*/_react.default.createElement(_ContextProvider.BiContext.Consumer, null, biContext => {
          const {
            contextForwardRef,
            ...others
          } = this.props;
          const newProps = {};
          if (biContext) {
            if (args == null || args.length === 0) {
              newProps.context = biContext;
            } else {
              args.forEach(arg => addProperty(newProps, biContext, arg, this.props));
            }
          }
          return /*#__PURE__*/_react.default.createElement(ComponentClass, (0, _extends2.default)({}, others, newProps, {
            ref: contextForwardRef
          }));
        });
      }
    }
    (0, _defineProperty2.default)(WithContext, "propTypes", {
      contextForwardRef: _propTypes.default.any
    });
    (0, _defineProperty2.default)(WithContext, "contextTypes", {
      biContext: _propTypes.default.object
    });
    WithContext.WrappedComponent = ComponentClass;
    return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(WithContext, (0, _extends2.default)({}, props, {
      contextForwardRef: ref
    })));
  };
}

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 580:
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(12099));
/******/ return __webpack_exports__;
/******/ }
]);
});